import React, { useState, useEffect, useRef } from 'react';
import { Form, Button } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const getKeywordFromPath = (pathname) => {
  const match = pathname.match(/\/search\/([^/]+)/);
  if (!match) return '';
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return match[1];
  }
};

const SearchBox = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const urlKeyword = getKeywordFromPath(location.pathname);
  const [keyword, setKeyword] = useState(urlKeyword);
  const debounceRef = useRef(null);
  const skipNextSearch = useRef(false);

  const getSearchRoutes = () => {
    const path = location.pathname;
    if (path.includes('/online') || path.includes('/category/online')) {
      return { searchRoute: '/online/search', homeRoute: '/online' };
    }
    if (path.includes('/other') || path.includes('/category/other')) {
      return { searchRoute: '/other/search', homeRoute: '/other' };
    }
    return { searchRoute: '/search', homeRoute: '/' };
  };

  const runSearch = (value) => {
    const { searchRoute, homeRoute } = getSearchRoutes();
    const trimmed = value.trim();

    if (trimmed) {
      navigate(`${searchRoute}/${encodeURIComponent(trimmed)}`);
    } else {
      navigate(homeRoute);
    }
  };

  // Sync input when URL changes (browser back/forward, navigation)
  useEffect(() => {
    skipNextSearch.current = true;
    setKeyword(urlKeyword);
  }, [urlKeyword]);

  // Live filter while typing
  useEffect(() => {
    if (skipNextSearch.current) {
      skipNextSearch.current = false;
      return;
    }

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      if (keyword.trim() === urlKeyword.trim()) return;
      runSearch(keyword);
    }, 350);

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    runSearch(keyword);
  };

  return (
    <Form className='d-flex header-search-form' onSubmit={handleSubmit}>
      <Form.Control
        type='search'
        name='q'
        onChange={(e) => setKeyword(e.target.value)}
        value={keyword}
        placeholder={t('searchPlaceholderNav', { defaultValue: t('searchby') })}
        autoComplete='off'
      />
      <Button type='submit' className='btn-teal border-0'>
        {t('searchNav', { defaultValue: t('search') })}
      </Button>
    </Form>
  );
};

export default SearchBox;
